<template>
    <section class="p-[16px]">
        <div class="mb-[16px] flex items-center justify-between">
                <h2 class="text-[18px] text-[#2b2b2b] font-light">Horaire</h2>
            </div>
        <div class="">

            <ShiftsTableComponent />

            <div class="block-header">
                <h2>AJOUTER UN NOUVEAU SERVICE</h2>
            </div>

            <NewShiftComponent />
        </div>
    </section>
</template>

<script>
import ShiftsTableComponent from '@/components/tables/ShiftsTable'
import NewShiftComponent from '@/components/create/NewShift'
import {
    createColumnHelper,
  getCoreRowModel,
  getPaginationRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useVueTable,
} from "@tanstack/vue-table";

const columnHelper = createColumnHelper();

const columns = [
  columnHelper.accessor('name', {
    header: 'Nom du Produit',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor('category', {
    header: 'Catégorie',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor('price', {
    header: 'Prix (€)',
    cell: info => `${info.getValue()} €`,
  }),
  columnHelper.accessor('stock', {
    header: 'Stock',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor('date', {
    header: 'Date Ajout',
    cell: info => info.getValue(),
    sortingFn: (rowA, rowB, columnId) => {
        const dateA = new Date(rowA.getValue(columnId));
        const dateB = new Date(rowB.getValue(columnId));
        return dateA.getTime() - dateB.getTime();
    }
  }),
];
export default {
    name: 'DepartementView',
    components: {
        NewShiftComponent,
        ShiftsTableComponent,
    },
    data() {
        return {
            loader: false,
            data: [
                { id: 1, name: 'Ordinateur Portable', category: 'Électronique', price: 1200, stock: 50, date: '2023-01-15' },
                { id: 2, name: 'Bureau Ergonomique', category: 'Mobilier', price: 450, stock: 20, date: '2023-02-01' },
                { id: 3, name: 'Clavier Mécanique', category: 'Électronique', price: 150, stock: 100, date: '2023-01-20' },
                { id: 4, name: 'Chaise de Bureau', category: 'Mobilier', price: 300, stock: 30, date: '2023-03-10' },
            ],
            globalFilter: '',
            pagination: {
                pageIndex: 0,
                pageSize: 10,
            },
            sorting: [],
        }
    },
    mounted() {
        this.loadpage()
    },
    computed: {
        columns() {
            return columns;
            },
            table() {
            return useVueTable({
                data: this.data,
                columns: this.columns,
                getCoreRowModel: getCoreRowModel(),
                getPaginationRowModel: getPaginationRowModel(),
                getFilteredRowModel: getFilteredRowModel(),
                getSortedRowModel: getSortedRowModel(),
                state: {
                pagination: this.pagination,
                globalFilter: this.globalFilter,
                sorting: this.sorting,
                },
                onPaginationChange: updater => {
                this.pagination = typeof updater === 'function' ? updater(this.pagination) : updater;
                },
                onGlobalFilterChange: updater => {
                this.globalFilter = typeof updater === 'function' ? updater(this.globalFilter) : updater;
                },
                onSortingChange: updater => {
                this.sorting = typeof updater === 'function' ? updater(this.sorting) : updater;
                },
            });
        },
    },
    methods: {
        loadpage() {
            this.loader = true
            var data = this
            setTimeout(() => {
                data.loader = false
            }, 500);
        }
    }
}

</script>